import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/system';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import lightTheme from './lightTheme';
import darkTheme from './darkTheme';

const loadTheme = (theme) => {
	return theme === 'light' ? lightTheme : darkTheme;
};

const Theme = ({ children }) => {
	const theme = useSelector((state) => state.systemSlice.theme);

	return (
		<ThemeProvider theme={loadTheme(theme)}>
			<CssBaseline />
			{children}
		</ThemeProvider>
	);
};

Theme.propTypes = {
	children: PropTypes.element,
	theme: PropTypes.string
};

export default Theme;
